import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDmKetQuaLienHeActionTypes } from "../../action-types/crm-category/IDmKetQuaLienHeActionTypes";
import { IDmKetQuaLienHeReducer } from "../../page-state-model/crm-category/IDmKetQuaLienHeReducer";

const iniState: IDmKetQuaLienHeReducer = {
    status: ePageBaseStatus.is_not_initialization,
    ketQuaLienHes: []
}

export const dmKetQuaLienHeReducer = (state: IDmKetQuaLienHeReducer = iniState, action: IDmKetQuaLienHeActionTypes): IDmKetQuaLienHeReducer => {
    switch (action.type) {
        case "DM_KET_QUA_LIEN_HE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DM_KET_QUA_LIEN_HE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ketQuaLienHes: action.payload
            }
        case "DM_KET_QUA_LIEN_HE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ketQuaLienHes: []
            }
        case "DM_KET_QUA_LIEN_HE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "DM_KET_QUA_LIEN_HE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "DM_KET_QUA_LIEN_HE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "DM_KET_QUA_LIEN_HE_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "DM_KET_QUA_LIEN_HE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "DM_KET_QUA_LIEN_HE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "DM_KET_QUA_LIEN_HE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "DM_KET_QUA_LIEN_HE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}
